import v from "./ghl-ui.es1184.js";
import S from "./ghl-ui.es1157.js";
const f = (C) => {
  const {
    textColor2: r,
    primaryColor: o,
    textColorDisabled: t,
    closeIconColor: i,
    closeIconColorHover: s,
    closeIconColorPressed: n,
    closeColorHover: c,
    closeColorPressed: d,
    tabColor: a,
    baseColor: x,
    dividerColor: T,
    fontWeight: l,
    textColor1: e,
    borderRadius: b,
    fontSize: g,
    fontWeightStrong: m
  } = C;
  return Object.assign(Object.assign({}, v), {
    colorSegment: a,
    tabFontSizeCard: g,
    tabTextColorLine: e,
    tabTextColorActiveLine: o,
    tabTextColorHoverLine: o,
    tabTextColorDisabledLine: t,
    tabTextColorSegment: e,
    tabTextColorActiveSegment: r,
    tabTextColorHoverSegment: r,
    tabTextColorDisabledSegment: t,
    tabTextColorBar: e,
    tabTextColorActiveBar: o,
    tabTextColorHoverBar: o,
    tabTextColorDisabledBar: t,
    tabTextColorCard: e,
    tabTextColorHoverCard: e,
    tabTextColorActiveCard: o,
    tabTextColorDisabledCard: t,
    barColor: o,
    closeIconColor: i,
    closeIconColorHover: s,
    closeIconColorPressed: n,
    closeColorHover: c,
    closeColorPressed: d,
    closeBorderRadius: b,
    tabColor: a,
    tabColorSegment: x,
    tabBorderColor: T,
    tabFontWeightActive: l,
    tabFontWeight: l,
    tabBorderRadius: b,
    paneTextColor: r,
    fontWeightStrong: m
  });
}, h = {
  name: "Tabs",
  common: S,
  self: f
}, H = h;
export {
  H as default,
  f as self
};
